// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"34":"08c91146","75":"29b45a2b","433":"237df238","446":"cb773441","453":"a1da80f4","466":"4691f0db","484":"4e0b5486","559":"f08a8d07","654":"b750e01e","727":"f52bcda3","768":"21580387","976":"01b3d2bc","992":"53fefe37"}[chunkId] + ".chunk.js";
};